import { useState, useEffect } from "react";

import API from "utils/api";
import { anyToHash } from "utils/misc";
import { useUser } from "utils/hooks";

export default function useTransactions(filters) {
  const { token } = useUser();
  const [result, setResult] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function fetchTransactions() {
      setLoading(true);
      const { response, data } = await API.fetchTransactions(token, filters);

      if (response.ok) {
        setResult(data);
      }

      setLoading(false);
    }

    fetchTransactions();
  }, [anyToHash(filters)]);

  return {
    loading,
    transactions: result?.results ?? [],
    count: result?.count ?? 0,
    limit: result?.limit ?? 0,
    page: result?.page ?? 0,
  };
}
